<template>
 <div class="container">
    <p style="color:red;">考号{{ kaohao }}</p>
    <p>{{ xm }}</p><p>{{ sb }}</p>
    
     <el-row> 
    <div  class="imgdiv" :style="{ background: '#f2f2f2',height: '100%', width: screenWidth - 50 + 'px' }">     
        <div id="panzoom-element" z-index:-1  :style="{ background: '#f2f2f2',height: imgShowHeight - 10 + 'px', width: imgShowWidth + 'px' }"> 	
          
            <img 
            v-show="img_src!=''"
            ref="imgSize"						
            :src="img_src" 	
            :style="{height: imgShowHeight - 10 + 'px', width: imgShowWidth  + 'px' }" 
		      	@load='justifyImgWidth($event)' 
        
            />
      
        </div>
      </div>  
     </el-row> 
  
  </div>
</template>


<script>
import axios from 'axios'
import qs from 'qs'
import Panzoom from '@panzoom/panzoom'

export default {
  data() {
    return {
      msg: '',
        // 保存传递过来的index
        myIndex: '',
        img_src:'',
        xm:'',
        sb:'',
        kaohao:'',
        page:'',
        screenWidth: document.body.clientWidth-80,
        imgShowHeight:0,
	      imgShowWidth:0,
    }
  },
 
  activated: function () {

    	const elem = document.getElementById('panzoom-element')
      const panzoom = Panzoom(elem, {
      maxScale: 2,
      minScale:0.1,
      step:0.1
      });
      elem.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);


      const that = this;
			window.onresize = () => {
				return (() => {
					window.screenHeight = document.body.clientHeight
					that.screenHeight = window.screenHeight-80
					that.screenWidth = window.screenWidth-100
				})()
      }
      
  
       this.img_src ='';
       this.msg = this.$route.params.msgKeyOne
    //  this.myIndex = this.$route.params.msgKey
      console.log(this.myIndex)
      console.log(this.msg)
      this.xm=this.$route.params.xm;
      this.sb=this.$route.params.sb;
      this.kaohao=this.$route.params.kaohao;
      this.page=this.$route.params.page;

       axios.post('/redis.php',qs.stringify({"xm":this.xm,"sb":this.sb,"kaohao":this.kaohao,"page":this.page}),{responseType: 'blob'}).then((res)=>{
              console.log(res.data)

              var urlCreator = window.URL || window.webkitURL;
								var imageUrl = urlCreator.createObjectURL( res.data );
                this.img_src = imageUrl; 
                console.log(res.headers);
              console.log(res.headers['x-powered-by']);
              
              
          }).catch((res)=>{
              console.log(res)
          })





    },
    methods: {

	  
		   justifyImgWidth (e) {
			  // ratio = orgin width / origin height = 968 / 352 = 2.75
			   let imgSize = this.$refs['imgSize'].offsetHeight;
				console.log(imgSize);
				
				let imgHeight= this.$refs['imgSize'].naturalHeight
				console.log(imgHeight);

				let imgWidth= this.$refs['imgSize'].naturalWidth
				console.log(imgWidth);

				 
				 let imageRatio=imgWidth/imgHeight;
				 let screenRation=this.screenWidth/this.screenWidth;

				 if (imageRatio>screenRation)
				 {

				 }
				 else
				 {

				 }

				if (imgHeight>imgWidth)
				{
					this.imgShowHeight=this.screenHeight-10;
					this.imgShowWidth=(this.screenHeight-10)*imgWidth/imgHeight;

				}
				else
				{
					this.imgShowWidth=this.screenWidth-100;
					this.imgShowHeight=(this.screenWidth-100)*imgHeight/imgWidth;
					//如果高度超过屏幕高度
					if (this.imgShowHeight>this.screenHeight)
					{
						let ratio=this.screenHeight/this.imgShowHeight;
						this.imgShowHeight=ratio*this.imgShowHeight;
						this.imgShowWidth=ratio*this.imgShowWidth;


					}
					

				}

			this.logoWidth = 0
      },
    }
}

</script>

<style lang="scss">
.imgdiv{
       
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>